// import React from 'react';
// import { useQuery } from '@apollo/client';
// import { defaultFiltersForDates } from 'pages/Dashboard/components/constant';
// import { VENDOR_DATA } from 'pages/Dashboard/components/DashboardGraphQL';
// import Loader from 'components/common/Loader';
// import LineChart from '../../../LineChart';

// const VendorChart = ({ selectedOption }) => {
//   const { data, loading, error } = useQuery(VENDOR_DATA, {
//     variables: defaultFiltersForDates(selectedOption),
//     fetchPolicy: 'network-only',
//   });
//   if (error) return `There is an error on this page : ${error.message} `;
//   if (loading)
//     return (
//       <div className="linechart-loader">
//         <Loader />
//       </div>
//     );

//   const combinedKeysSet = new Set();
//   let firstLineData = [];
//   const secondLineData = [];

//   if (data.vendorsCountData && data.vendorsCountData.NEW?.length) {
//     firstLineData = data.vendorsCountData.NEW.map((val) => {
//       combinedKeysSet.add(val[defaultFiltersForDates(selectedOption).groupOn]);
//       return val.count;
//     });
//   }
//   // if (data.vendorsCountData && data.vendorsCountData.TOTAL?.length) {
//   //   secondLineData = data.vendorsCountData.TOTAL.map((val) => {
//   //     console.log(
//   //       '====>>>',
//   //       defaultFiltersForDates(selectedOption),
//   //       val[defaultFiltersForDates(selectedOption).groupOn],
//   //       val.count
//   //     );
//   //     combinedKeysSet.add(val[defaultFiltersForDates(selectedOption).groupOn]);
//   //     return val.count;
//   //   });
//   // }
//   const combinedKeys = Array.from(combinedKeysSet);

//   return (
//     <>
//       {' '}
//       <LineChart
//         combinedKeys={combinedKeys}
//         firstLineData={firstLineData}
//         secondLineData={secondLineData}
//         firstHeading="New Vendors"
//         secondHeading="Total Vendors"
//       />
//     </>
//   );
// };

// export default VendorChart;

// import React from 'react';
// import { useQuery } from '@apollo/client';
// import { defaultFiltersForDates, formatXAxisLabels } from 'pages/Dashboard/components/constant';
// import { VENDOR_DATA } from 'pages/Dashboard/components/DashboardGraphQL';
// import Loader from 'components/common/Loader';
// import LineChart from '../../../LineChart';

// const VendorChart = ({ selectedOption }) => {
//   const { data, loading, error } = useQuery(VENDOR_DATA, {
//     variables: defaultFiltersForDates(selectedOption),
//     fetchPolicy: 'network-only',
//   });

//   if (error) return `There is an error on this page : ${error.message} `;
//   if (loading)
//     return (
//       <div className="linechart-loader">
//         <Loader />
//       </div>
//     );

//   let firstLineData = [];
//   const secondLineData = [];

//   const xAxisLabels = formatXAxisLabels(selectedOption);

//   if (data?.vendorsCountData?.NEW?.length) {
//     firstLineData = data.vendorsCountData.NEW.map((val) => val.count);
//   }

//   while (firstLineData.length < xAxisLabels.length) {
//     firstLineData.push(0);
//   }

//   return (
//     <LineChart
//       combinedKeys={xAxisLabels}
//       firstLineData={firstLineData}
//       secondLineData={secondLineData}
//       firstHeading="New Vendors"
//       secondHeading="Total Vendors"
//     />
//   );
// };

// export default VendorChart;

import React from 'react';
import moment from 'moment';
import { useQuery } from '@apollo/client';
import {
  defaultFiltersForDates,
  formatXAxisLabels,
} from 'pages/Dashboard/components/constant';
import { VENDOR_DATA } from 'pages/Dashboard/components/DashboardGraphQL';
import PermissionNotice from 'pages/Dashboard/components/PermissionNotice';
import Loader from 'components/common/Loader';
import LineChart from '../../../LineChart';

const VendorChart = ({ selectedOption, canView = true }) => {
  const { data, loading, error } = useQuery(VENDOR_DATA, {
    variables: defaultFiltersForDates(selectedOption),
    fetchPolicy: 'network-only',
    skip: !canView,
  });

  if (!canView) {
    return (
      <PermissionNotice message="You do not have permission to view Vendors chart." />
    );
  }

  if (error) return `There is an error on this page : ${error.message}`;
  if (loading)
    return (
      <div className="linechart-loader">
        <Loader />
      </div>
    );

  let firstLineData = [];
  const secondLineData = [];

  let xAxisLabels = formatXAxisLabels(selectedOption);

  if (data?.vendorsCountData) {
    const { NEW } = data.vendorsCountData;

    if (selectedOption === 'this_year') {
      // Month-wise mapping
      const newMap = {};
      NEW?.forEach((item) => {
        const month = moment(item.day || item.month).format('MMM');
        newMap[month] = (newMap[month] || 0) + parseInt(item.count || 0, 10);
      });

      firstLineData = xAxisLabels.map((label) => newMap[label] || 0);
    } else {
      // Day-wise mapping
      const newMap = {};

      NEW?.forEach((item) => {
        const date = moment(item.day).format('D MMM');
        newMap[date] = parseInt(item.count, 10) || 0;
      });

      xAxisLabels = xAxisLabels.filter((label) => {
        const date = moment(label, 'D MMM');
        return date.day() !== 0; // 0 = Sunday
      });

      firstLineData = xAxisLabels.map((label) => newMap[label] || 0);
    }
  }

  return (
    <LineChart
      combinedKeys={xAxisLabels}
      firstLineData={firstLineData}
      secondLineData={secondLineData}
      firstHeading="Total New Vendors"
      secondHeading="Total Vendors"
      hideSecondLine
    />
  );
};

export default VendorChart;
